export { default } from './ForecastIcon';
